import React, {useEffect} from 'react';
import logo_new from "../assets/logo_new.png"
import FaqItem from '../components/FaqItem';
import Calculator from '../components/Calculator';
import OrderStatusTracker from '../components/OrderStatusTracker';
import WhatsappIcon from '../components/WhatsappIcon';
import { useLocation, useNavigate } from 'react-router-dom';
import lenis from '../lenis';

import heroImage from '../assets/Hero12.png';
import banderaUsa from '../assets/bandera_usa.png';
import banderaChina from '../assets/bandera_china.png';
import imagenRastreo from '../assets/imagen_rastreo.png';
import FondoCalculadora from '../assets/FondoCalculadora.png';
import IzquierdaCalculadora from '../assets/IzquierdaCalculadora.png';
import DerechaCalculadora from '../assets/DerechaCalculadora.png';

import faqs from '../components/preguntas';

function HomePage() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
    if (location.state && location.state.scrollToId) {
        setTimeout(() => {
            // Usa las opciones que vienen en el state, o las por defecto si no vienen
            const options = location.state.scrollOptions || { offset: 0};
            lenis.scrollTo(location.state.scrollToId, options);
            navigate(location.pathname, { replace: true, state: null });
        }, 100);
    }
}, [location.state, navigate]);

    return (
        <div>
         {/* --- SECCIÓN 1: INICIO --- */}
            <div
              id="inicio"
              className="relative min-h-screen flex justify-center overflow-hidden bg-black"
            >
              {/* Imagen hero */}
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: `url(${heroImage})`,
                }}
              />
            
                  {/* Contenido */}
                    <div className="relative z-4 w-full px-4 sm:px-6 md:px-10 min-h-[70vh] flex items-start justify-center pt-[8vh] sm:pt-[6vh] md:pt-[4vh]">                      <div className="max-w-3xl mx-auto text-center">
                        <h1 className="text-2xl sm:text-4xl md:text-6xl lg:text-6xl  font-sans text-white font-bold tracking-tight">
                          Importa ahora con
                        </h1>
                    
                        <h2 className="text-2xl sm:text-4xl md:text-6xl lg:text-6xl font-sans text-[#A9F52A] font-bold tracking-tight">
                          KIFLI
                        </h2>
                    
                        <p className="max-w-xl mx-auto mt-2 text-[20px] sm:text-lg md:text-2xl text-[#D7D2D2] font-light">
                          Desde el asesoramiento hasta su llegada a Ecuador, nos aseguramos de que
                          tu compra sea segura y al mejor precio.
                        </p>
                      
                
                      <a
                        href="https://api.whatsapp.com/send/?phone=593982968185&text&type=phone_number&app_absent=0"
                        className="
                          mt-6 sm:mt-8 mx-auto inline-flex items-center gap-2 sm:gap-3
                          bg-lime-400 text-black font-bold uppercase
                          text-sm sm:text-base
                          py-2 sm:py-3
                          px-6 sm:px-8
                          rounded-full
                          hover:bg-white hover:text-lime-400
                          transition-colors duration-300
                        "
                      >
                        <WhatsappIcon className="w-5 h-5 sm:w-6 sm:h-6" />
                        <span>Chatea aquí</span>
                      </a>
                    </div>
                  </div>
            
              {/* Gradiente inferior */}
              <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#222222] to-transparent pointer-events-none" />
            </div>


          {/* --- SECCIÓN 2: RASTREO --- */}
          <div id='rastreo' className="py-10 bg-cover"> {/* Ajustado para que el fondo sea consistente */}
              <div className=" max-w-4xl mx-auto bg-[#292929] rounded-3xl shadow-lg px-6 py-6 sm:px-8 sm:py-8 md:px-10 md:py-10">
                  <div className="flex flex-col md:flex-row items-center justify-center gap-4">
                      <div className="md:w-2/5 px-6">
                          <h2 className="text-2xl sm:text-3xl md:text-4xl font-sans font-bold tracking-tight mb-6 text-center">
                              Rastrea tus pedidos en tiempo real
                          </h2>
                          <p className=" text-base sm:text-lg md:text-2xl text-gray-300 font-light text-center">
                              Revisa el progreso de tus envíos en cualquier momento y mantente informado hasta la entrega.
                          </p>
                      </div>
                      <div className="md:w-3/5 flex justify-center items-center rounded-lg text-gray-500 relative overflow-hidden">
                          <img 
                              src={imagenRastreo}
                              alt="Kifli Hero" 
                              className=" w-full max-h-[220px] sm:max-h-[280px] md:max-h-none object-contain"
                          />

                          <div className="absolute right-0 top-0 h-full w-1/3 bg-gradient-to-l from-[#292929] to-transparent pointer-events-none"></div>
                      </div>
                  </div>
              </div>
          </div>

          {/* --- SECCIÓN 3: CALCULADORA --- */}
          <div
          id="calculadora"
          className="relative z-0 w-full bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${FondoCalculadora})` }}
          >
              <div className="relative wave-container pt-16 pb-6 md:pt-16">

                  <img
                  src={IzquierdaCalculadora}
                  alt="Decoración izquierda"
                  className="absolute left-0 top-0 bottom-0 w-[420px] md:w-[520px] lg:w-[620px] pointer-events-none z-0"
                  />

                  <img
                  src={DerechaCalculadora}
                  alt="Decoración derecha"
                  className="absolute right-0 top-0 bottom-0 w-[420px] md:w-[520px] lg:w-[620px] pointer-events-none z-0"
                  />

                  {/* Calculator centrado y contenido */}
                  <div className="relative z-10 px-4 pt-12 pb-0">
                      <Calculator />
                  </div>

              </div>
          </div>


          {/* --- SECCIÓN 4: COMO FUNCIONA --- */}
          <div id="como-funciona" className="bg-[#222222] py-10">
              <div className="max-w-screen-xl mx-auto px-4 md:px-8">
                  <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-16">
                  ¿Cómo Funciona?
                  </h2>
  
                  <div
                  className="
                     grid grid-flow-col
                     auto-cols-[180px]       // mobile
                     sm:auto-cols-[220px]    // phones grandes
                     md:auto-cols-[260px]    // tablet
                     lg:auto-cols-fr         // desktop normal
                     gap-8 sm:gap-10 lg:gap-12
                     text-center
                     item-center
                     overflow-x-auto
                     lg:overflow-x-visible
                     pb-4
                     snap-x snap-mandatory
                     scroll-smooth
                  "
                  >
  
                      {/* PASO 1 */}
                      <div>
                          <svg viewBox="0 -960 960 960" fill="currentColor"
                          className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6">
                          <path d="m480-560-56-56 63-64H320v-80h167l-64-64 57-56 160 160-160 160ZM280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM40-800v-80h131l170 360h280l156-280h91L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68.5-39t-1.5-79l54-98-144-304H40Z"/>
                          </svg>
  
                          <div className="text-3xl font-bold text-lime-400 mb-3">1</div>
                        
                          {/* <h3 className="text-xl sm:text-2xl font-bold mb-3"> */}
                          <h3 className="text-lg sm:text-xl font-semibold mb-3">
                          Elige los productos que deseas comprar
                          </h3>
                          <p className="text-gray-400 text-base sm:text-lg md:text-center">
                          Compra en cualquier tienda de EE. UU. y selecciona los artículos que quieres traer a Ecuador.
                          </p>
                      </div>
  
                      {/* PASO 2 */}
                      <div>
                          <svg viewBox="0 -960 960 960" fill="currentColor"
                          className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6">
                          <path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/>
                          </svg>
  
                          <div className="text-3xl font-bold text-lime-400 mb-3">2</div>
                          <h3 className="text-lg sm:text-xl font-semibold mb-3">
                          Cotiza tu compra por WhatsApp
                          </h3>
                          <p className="text-gray-400 text-base sm:text-lg md:text-center">
                          Envíanos el enlace o detalle del producto. Si no sabes dónde encontrarlo, ¡nosotros te ayudamos sin costo!
                          </p>
                      </div>
  
                      {/* PASO 3 */}
                      <div>
                          <svg viewBox="0 -960 960 960" fill="currentColor"
                          className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6">
                          <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q8 0 15 1.5t14 4.5l-74 74H200v560h560v-266l80-80v346q0 33-23.5 56.5T760-120H200Zm261-160L235-506l56-56 170 170 367-367 57 55-424 424Z"/>
                          </svg>
  
                          <div className="text-3xl font-bold text-lime-400 mb-3">3</div>
                          <h3 className="text-lg sm:text-xl font-semibold mb-3">
                          Elige tu servicio
                          </h3>
                          <p className="text-gray-400 text-base sm:text-lg md:text-center">
                          Selecciona entre Servicio PRO o KIFIX según la urgencia de tu pedido.
                          </p>
                      </div>
  
                      {/* PASO 4 */}
                      <div>
                          <svg viewBox="0 -960 960 960" fill="currentColor"
                          className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6">
                          <path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z"/>
                          </svg>
  
                          <div className="text-3xl font-bold text-lime-400 mb-3">4</div>
                          <h3 className="text-lg sm:text-xl font-semibold mb-3">
                          Dirección de envio
                          </h3>
                          <p className="text-gray-400 text-base sm:text-lg md:text-center">
                          Compra usando tu dirección Kifli o solicita nuestro servicio de préstamo de tarjeta.
                          </p>
                      </div>
  
                      {/* PASO 5 */}
                      <div>
                          <svg viewBox="0 -960 960 960" fill="currentColor"
                          className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6">
                          <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q152 0 263.5 98T876-538q-20-10-41.5-15.5T790-560q-19-73-68.5-130T600-776v16q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q11 0 20.5 5.5T595-459q-17 27-26 57t-9 62q0 63 32.5 117T659-122q-41 20-86 31t-93 11Zm-40-82v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm340 82q-7 0-12-4t-7-10q-11-35-31-65t-43-59q-21-26-34-57t-13-65q0-58 41-99t99-41q58 0 99 41t41 99q0 34-13.5 64.5T873-218q-23 29-43 59t-31 65q-2 6-7 10t-12 4Zm0-113q10-17 22-31.5t23-29.5q14-19 24.5-40.5T860-340q0-33-23.5-56.5T780-420q-33 0-56.5 23.5T700-340q0 24 10.5 45.5T735-254q12 15 23.5 29.5T780-193Zm0-97q-21 0-35.5-14.5T730-340q0-21 14.5-35.5T780-390q21 0 35.5 14.5T830-340q0 21-14.5 35.5T780-290Z"/>
                          </svg>
  
                          <div className="text-3xl font-bold text-lime-400 mb-3">5</div>
                          <h3 className="text-lg sm:text-xl font-semibold mb-3">
                          Haz seguimiento de tu envío
                          </h3>
                          <p className="text-gray-400 text-base sm:text-lg md:text-center">
                          Desde Tracking podrás ver el estado de tu paquete hasta que llegue a Ecuador.
                          </p>
                      </div>
                  </div>
              </div>
          </div>


            {/* SECCION 5: NOSOTROS */}
            <div
              id="nosotros"
              className="relative bg-black py-12 sm:py-16 md:py-20 overflow-hidden"
            >
              {/* Imagen de fondo */}
              <div
                className="absolute inset-0 bg-cover bg-center opacity-30"
                style={{
                  backgroundImage:
                    "url('https://images.unsplash.com/photo-1521791136064-7986c2920216')",
                }}
              />
            
              {/* Contenido */}
              <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-8 flex flex-col md:flex-row items-center gap-8 md:gap-12">
            
                {/* Logo */}
                <div className="md:w-1/2 flex justify-center">
                  <img
                    src={logo_new}
                    alt="Logo de Kifli"
                    className="
                      h-[180px] sm:h-[220px] md:h-[300px]
                      w-auto object-contain
                    "
                  />
                </div>
            
                {/* Texto */}
                <div className="md:w-1/2 relative p-6 sm:p-8 md:p-10">
                  
                  {/* Gradiente */}
                  <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent rounded-xl" />
            
                  <div className="relative">
                    <h2
                      className="
                        text-3xl sm:text-4xl md:text-[48px]
                        text-lime-400 font-bold tracking-tight mb-4 sm:mb-6
                      "
                    >
                      Sobre Nuestra Empresa
                    </h2>
            
                    <p className="text-base sm:text-lg text-gray-300 font-light mb-3 sm:mb-4 text-justify">
                      Somos Kifli, una empresa dedicada a revolucionar la forma de compra y
                      recepción de tus productos. Nuestra misión es ofrecerte una experiencia
                      transparente, segura y eficiente, combinando tecnología moderna con
                      procesos optimizados.
                    </p>
            
                    <p className="text-base sm:text-lg text-gray-300 font-light text-justify">
                      Fundada en 2024, nuestra plataforma integra innovación digital con un
                      enfoque centrado en el cliente, garantizando control, trazabilidad y
                      confianza en cada pedido que realizas con nosotros.
                    </p>
                  </div>
                </div>
              </div>
            </div>
           {/* SECCION 6: FAQs */}
            <div id="faq" className="bg-[#222222] py-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                <h2 className="
                  text-3xl sm:text-4xl md:text-5xl
                  font-sans font-bold text-lime-400
                  tracking-tight text-center mb-8 sm:mb-12
                ">
                  Preguntas Frecuentes
                </h2>
                    <div
                      className="
                        max-w-4xl mx-auto
                        space-y-4
                        text-sm
                        sm:text-base
                        md:text-lg
                      "
                    >
                      {faqs.map((faq, index) => (
                        <FaqItem
                          key={index}
                          question={faq.question}
                          answer={faq.answer}
                        />
                      ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;
